import React from 'react';
import styled from 'styled-components';
import { ControlDescription } from '@ad-scripts/presentation/components/common/forms/control_container';
import { CHAT_BRAND } from 'src/constants/branding';

const NoAudiencesCreated = styled.div`
  ${({ section }) =>
    section === CHAT_BRAND.name &&
    `width: 500px;
     margin-bottom: 24px;
  `}
`;

function NoAudiencesCreatedDisplay({ section }) {
  return (
    <NoAudiencesCreated section={section}>
      <h4>Audiences</h4>
      <ControlDescription>
        <a href="/admin/audiences">Create an Audience</a> now and assign it to your Answers. Once you&apos;ve assigned
        an Audience to an Answer, you will be able to select it for your {section}.
      </ControlDescription>
    </NoAudiencesCreated>
  );
}

export default NoAudiencesCreatedDisplay;
